// src/components/InfoCard.tsx
import React from "react";
import { LucideIcon } from "lucide-react";

interface InfoCardProps {
  title: string;
  value: number | string;
  icon?: LucideIcon;
  iconColor?: string; // Tailwind renk sınıfı
  bgColor?: string;   // Tailwind bg rengi
  label?: string;     // Sağ üstte gösterilecek opsiyonel label
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  value,
  icon: Icon,
  iconColor = "text-white",
  bgColor = "bg-blue-500",
  label,
}) => {
  return (
    <div className="relative flex items-center p-4  card transition-shadow duration-300">
      {label && (
        <span className="absolute top-2 right-2 text-xs font-semibold text-gray-500 dark:text-gray-400">
          {label}
        </span>
      )}

      {Icon && (
        <div className={`p-3 rounded-full ${bgColor} mr-4 flex items-center justify-center`}>
          <Icon className={`w-6 h-6 ${iconColor}`} />
        </div>
      )}

      <div className="mt-3 w-full">
        <p className="text-sm ">{title}</p>
        <p className="text-2xl font-bold text-right ">{value}</p>
      </div>
    </div>
  );
};
